import styled from 'styled-components';
import { Font } from 'web-common/src/shared/styles';
import { breakpointWidth } from '../constants';

export const Subtitle0 = styled.p`
  margin: 0;

  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: normal;

  font-size: 30px;
  line-height: 40px;

  @media only screen and (max-width: ${breakpointWidth}px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340650878851
 */
export const Body = styled.div`
  margin: 0;

  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: normal;

  font-size: 18px;
  line-height: 28px;

  strong {
    font-weight: 600;
  }

  @media only screen and (max-width: ${breakpointWidth}px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340650878851
 */
export const BodySmall = styled.p`
  margin: 0;

  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: normal;

  font-size: 14px;
  line-height: 24px;
`;

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340650878851
 */
export const DetailCallout = styled.p`
  margin: 0;

  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: 300;

  font-size: 40px;
  line-height: 50px;

  @media only screen and (max-width: ${breakpointWidth}px) {
    font-size: 30px;
    line-height: 40px;
  }
`;

export const DetailInfo = styled.p`
  margin: 0;

  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: normal;

  font-size: 24px;
  line-height: 34px;

  @media only screen and (max-width: ${breakpointWidth}px) {
    font-size: 20px;
    line-height: 30px;
  }
`;

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340650878851
 */
export const DetailCapsLarge = styled.p`
  margin: 0;

  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: normal;
  text-transform: uppercase;

  font-size: 18px;
  line-height: 18px;
`;

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340650878851
 */
export const DetailCapsSmall = styled.p`
  margin: 0;

  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: normal;
  text-transform: uppercase;

  font-size: 12px;
  line-height: 14px;
`;

// Breakpoint only present on mobile
export const MobileBr = styled.br<{ breakPoint?: number }>`
  display: none;
  @media only screen and (max-width: ${({ breakPoint }) => breakPoint}px) {
    display: unset;
  }
`;

MobileBr.defaultProps = {
  breakPoint: breakpointWidth,
};
